import { setSaveStatusBasedOnApiResponse } from '../grid/reduxStore/saveStatusSlice.ts';
import { updateGridPositionConfig } from '../grid/reduxStore/editorSlice.ts';
import { updateBlockPositionViaSocket } from '../grid/reduxStore/saveHandlers.ts';
import type { BlockCommandDependencies } from './BlockBaseCommand.ts';
import { BlockBaseCommand } from './BlockBaseCommand.ts';

export type PositionStateType = {
  xAxisPx: number;
  yAxisPx: number;
};

/**
 * Move block command
 *
 */

export class UpdateBlockPositionCommand extends BlockBaseCommand {
  readonly sectionId: string;

  private readonly blockId: string;
  private readonly previousPosition: PositionStateType;
  private readonly newPosition: PositionStateType;

  constructor(
    blockId: string,
    sectionId: string,
    previousPosition: PositionStateType,
    newPosition: PositionStateType,
    dependencies: BlockCommandDependencies
  ) {
    super(dependencies);
    this.blockId = blockId;
    this.sectionId = sectionId;
    this.previousPosition = { ...previousPosition };
    this.newPosition = { ...newPosition };
  }

  async undo(): Promise<boolean> {
    return this.updatePosition(this.previousPosition);
  }

  async redo(): Promise<boolean> {
    return this.updatePosition(this.newPosition);
  }

  private async updatePosition(position: PositionStateType): Promise<boolean> {
    try {
      this.setSaving();

      const response = await updateBlockPositionViaSocket(this.socketClient, {
        blockId: this.blockId,
        userId: this.userId,
        position: {
          top_px: position.yAxisPx,
          left_px: position.xAxisPx,
        },
      });

      if (this.checkDocumentLockStatus(response.errorCode)) {
        return false;
      }

      this.dispatch(
        updateGridPositionConfig({
          sectionId: this.sectionId,
          blockId: this.blockId,
          x: position.xAxisPx,
          y: position.yAxisPx,
        })
      );

      this.dispatch(setSaveStatusBasedOnApiResponse(response));

      return true;
    } catch (error) {
      console.error('Failed to update position:', error);
      if (error instanceof Error) {
        this.checkDocumentLockStatus(error.message as any);
      }
      this.setNotSaved();
      return false;
    }
  }

  getCurrentBlockId(): string {
    return this.blockId;
  }
}
